import script from "./newTransaction.vue?vue&type=script&setup=true&lang=ts"
export * from "./newTransaction.vue?vue&type=script&setup=true&lang=ts"

import "./newTransaction.vue?vue&type=style&index=0&id=23f48862&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23f48862"]])

export default __exports__